import DefaultModule from '../app/components/cmsModules/DefaultModule'
import ModuleAwardsHomePage from '../app/components/cmsModules/ModuleAwardsHomePage'
import ModuleAwardsPage from '../app/components/cmsModules/ModuleAwardsPage'
import ModuleDiscoverPage from '../app/components/cmsModules/ModuleDiscoverPage'
import ModulePanelPage from '../app/components/cmsModules/ModulePanelPage'
import ModuleContactPage from '../app/components/cmsModules/ModuleContactPage'
import ModuleMedallistPage from '../app/components/cmsModules/ModuleMedallistPage'
import ModulePartnerPage from '../app/components/cmsModules/ModulePartnerPage'
import ModulePartnerlogos from '../app/components/cmsModules/ModulePartnerlogos'
const moduleMap = {
  'awards-module.home-page': ModuleAwardsHomePage,
  'awards-module.discover': ModuleDiscoverPage,
  'awards-module.awards': ModuleAwardsPage,
  'awards-module.panellist': ModulePanelPage,
  'awards-module.contact': ModuleContactPage,
  'awards-module.medallist': ModuleMedallistPage,
  'awards-module.partner': ModulePartnerPage,
  'awards-module.partner-logos': ModulePartnerlogos,
  DefaultModule: DefaultModule
}

export default moduleMap
